import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";
import Spinner from "../Spinner";
import { Link } from "react-router-dom";
import { limitParagraphByCharLimit } from "../../Helper/Helper";

function CleanGridFeaturedServices({ setIsdata }) {
  const [featuredService, setFeaturedService] = useState([]);
  const [loading, setLoading] = useState(true);
  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    getFeaturedService();
  }, []);

  const getFeaturedService = async () => {
    setLoading(true);
    const response = await SendPostRequest("services/featured_services");
    if (response?.data.length < 5 && sitedata?.site_type === "hospitals") {
      setIsdata(true);
    }
    setFeaturedService(response?.data);
    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center">
          <Spinner />
        </div>
      ) : (
        featuredService?.length > 0 && (
          <div id="portfolio-section" className="portfolio-section pt-4 pb-0">
            <div className="container">
              <div className="row">
                <div className="offset-md-2 col-md-8">
                  <div className="title-wrap text-center">
                    <div className="section-title margin-bottom-60">
                      <h2 className="section-title margin-top-5 mb-0 text-uppercase">
                        {sitedata?.site_type === "hospitals" ? "Our Specialties" : "Services"}
                      </h2>
                      <span className="section-border-bottom center"></span>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="row portfolio-wrap portfolio-classic" data-animation="fadeInDown">
                    {featuredService?.slice(0, 6)?.map((service, index) => (
                      <div
                        className={`portfolio-item animated fadeInDown visible portfolio-overlay-wrap col-lg-4 col-md-4 col-sm-4 col-xs-6 filter ${service.category || 'general'}`}
                        key={index}
                      >
                        <div className="portfolio-thumb relative cleangrid-services-mobile-view">
                          <Link
                            to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                              .replaceAll(" ", "-")
                              .replaceAll("/", "-")}`}
                          >
                            <img
                              src={service?.service_image_url}
                              className="img-fluid"
                              alt={service?.title}
                              title={service?.service_title}
                              style={{ height: 'auto' }}
                            />
                          </Link>
                          <div className="portfolio-wrap">
                            <div className="portfolio-details-overlay home-speciality-title-color ">
                              <Link
                                to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                                  .replaceAll(" ", "-")
                                  .replaceAll("/", "-")}`}
                              >
                                <h4 className="mb-3 text-black">
                                  {service?.service_title}
                                </h4>
                              </Link>
                              <div className="portfolio-icons">
                                <Link
                                  to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                                    .replaceAll(" ", "-")
                                    .replaceAll("/", "-")}`}
                                  className="link-icon"
                                >
                                  <i className="icon-link text-white"></i>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      )}
    </>
  );
}

export default CleanGridFeaturedServices;